import React from "react";
import { makeStyles,useTheme } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import { useHistory } from 'react-router-dom';

import Button from "@material-ui/core/Button";
import Grid from '@material-ui/core/Grid';

import {ListItem,List,ListItemIcon,ListItemText} from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { StylesProvider } from '@material-ui/core/styles';
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
 import sendEventToEventLogs from '../helpers/events';

import { hidePrice } from "../config";
import '../assets/css/SimpleCardComponent.css'

import all from "../assets/homepage/ic_package1.svg";
const dualButtonEntityIds = ["11266804"];
const medibuddyUrl= "https://link.medibuddy.app/EfSTyvrMMWb"
const useStyles = makeStyles({
    root: {
        'padding-top': '40px',
        borderRadius: '15px',
        boxShadow: '0 0 10px 0 #e8e8e8',
        '& h5':{
          color:'#0a0e51',
          'font-family': 'Nunito',
          'font-size':'12px',
          'text-align': 'left',
          'margin-left': '20px',
           'border-radius': '45px',
           'background-color': '#FFE194',
           display: 'inline',
           'padding-left':'10px',
           'padding-right':'10px',
      },
      '& h4':{
        color:'#0a0e51',
        'font-family': 'Nunito',
        'font-size':'20px',
        'text-align': 'left',
        'margin-left': '20px',
         'border-radius': '45px',

      marginBottom: '10px',
      marginTop: '5px',
    }
  },
  content: {
    height: 'auto'
  },
  list: {
    marginTop: '30px',
  },
  listItem: {
    color: '#0a0e51',
  },
  button: {
    color: '#FFFFFF',
    alignItems: 'center',
    marginLeft: '30%',
    marginRight: '30%',
    backgroundColor: '#2e86f3',
    fontFamily: 'Nunito',
    fontWeight: 'bold',
    marginBottom: '20px',

  },
  dualButton: {
    margin: '0 auto 20px',
    width: '95%',
    color: '#FFFFFF',
    backgroundColor: '#2e86f3',
    fontFamily: 'Nunito',
    fontWeight: 'bold',
    marginBottom: '20px',
    minWidth: 180,        
    height: 48,           
    textTransform: 'none',
    borderRadius: 8,
    paddingLeft: '20px',
    paddingRight: '20px',
    '& .MuiButton-label': {
      fontSize: '1.1rem',
      lineHeight: 1.2,
    }       
  },
  images: {
    textAlign: 'center',
  },
  ulStyle: {
    marginTop: '-20px',
    marginLeft: '20px', 
    listStyleType: 'none', 
  },
  liStyle: {
    position: 'relative',
    paddingLeft: '20px',
    '&::before': {
      content: '""',
      position: 'absolute',
      left: '0',
      top: '50%',
      transform: 'translateY(-50%)',
      width: '8px',
      height: '8px',
      borderRadius: '50%',
      backgroundColor: '#D6AD60', 
    },
  },
});

export default function SimplePackageCardComponent(props) {
    const defaultButtonValue = 'Avail Now';
    const dualButtonValue = 'Activate Now';
    const classes = useStyles();
     const history = useHistory();
     const checkSource = () => {
      const source= localStorage.getItem("source");
       if(source =="tvs_credit" || source == "LandT" || source==='tvs_credit_emp'){
         return false;
       }
       else {
         return true;
       }
     };
     const buttonValue =()=> {
         const source= localStorage.getItem("source");
         let value = '';
         if(dualButtonEntityIds.includes(props.packag.pmEntityId))
          {
            return dualButtonValue;
          }
         value= props.packag.planButtonValue || defaultButtonValue;
         return value;
     }

     const displayButton = (event) => {
       const checkButton = checkSource();
       console.log("checkButon"+displayButton);
       if(checkButton){
        return( <Button variant="contained"
              color="primary"
              onClick={()=>custom()}
               className={classes.button}>
                {buttonValue()}
             </Button>
        );
       }

     };

  const custom = () => {
    gtag("event", "plan_selection", {
      price: props.packag.price,
      PackageName: props.packag.title,
      packageId: props.packag.id,
      walletAmount: props.packag.walletAmount,
    });
    sendEventToEventLogs("AFFINITY_PACKAGE_SELECTION", "");
    return history.push('/Checkout',
      { params: { packageDetails: props.packag, isAuthentic: true } })
  };
  let benefitIndex = 0;
  const benefitsList = (props.packag.content || []).map((benefit) => {
    ++benefitIndex;
    return (
      <div>
        <ListItem >
          <ListItemIcon><CheckCircleIcon style={{ color: "#FFE194" }} /> </ListItemIcon>
          <ListItemText className={classes.listItem}><div dangerouslySetInnerHTML={{ __html: benefit }} /></ListItemText>
        </ListItem>
        {props.packag && props.packag.subContents && typeof props.packag.subContentIndex === 'number' && Array.isArray(props.packag.subContents) && benefitIndex === props.packag.subContentIndex && props.packag.isSubContentList && (
            <ListItem>
              <ListItemText className={classes.listItem}>
                <ul className={classes.ulStyle}>
                  {props.packag.subContents.map((subContent, index) => (
                    <li key={index} className={classes.liStyle}>
                      {subContent}
                    </li>
                  ))}
                </ul>
              </ListItemText>
            </ListItem>
          )}
      </div>
    );
  });
  return (
    <Container>
       <Card className={classes.root}>
        <Grid container spacing={0}direction='row-reverse'>

        <Grid item xs={12} sm={6} md={6}
              direction="column"
              alignItems="flex-end"
              justify="flex-start" className={classes.images}
          >
              <img
                    className={classes.cover}
                    src={props.packag.image}
                    alignItems='right'
              />
            </Grid>
        <Grid item xs={12} sm={6} md={6} >
            {/* <CardContent className={classes.content}> */}
                        <h4>{props.packag.title}</h4>
            {!props.hidePrice && <h4>₹ {props.packag.strikePrice && (<del>{props.packag.strikePrice}</del>)} {props.packag.price}</h4>}
                        <h5>{props.packag.duration} </h5> 
                        <br></br>
                        <h5>{props.packag.members} {props.packag.members>1?'Members':'Member'}</h5>
                {/* </CardContent> */}
          </Grid>
        </Grid>

        <List className={classes.list}>
           {benefitsList}  
        </List>

        <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" width="100%" px={1} boxSizing="border-box" gap={2}>
        <Button variant="contained"
                color="primary"
                onClick={()=>custom()}
                className={
                  dualButtonEntityIds.includes(props.packag.pmEntityId)
                    ? classes.dualButton   
                    : classes.button       
                }>
            {buttonValue()}
                </Button>
        {dualButtonEntityIds.includes(props.packag.pmEntityId) && (
         <Button
         variant="contained"
         color="primary"
         href={medibuddyUrl}
         className={classes.dualButton}
        >
        Sign in to Medibuddy
       </Button>
        )}
        </Box>
      </Card>
    </Container>
  );
}
